"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@traqly/ui/lib/utils";

const labelVariants = cva(
  cn(
    "flex items-center gap-1.5 select-none",
    "group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
    "peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
  ),
  {
    variants: {
      variant: {
        default: "h-5 text-mono-900 text-body-medium-regular!",
        optional: "h-5 text-mono-900 text-body-medium-regular!",
        small: "text-mono-900 text-body-small-regular!",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

interface LabelProps
  extends
    React.ComponentProps<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {
  optional?: boolean;
  optionalText?: string;
}

function Label({
  className,
  variant,
  optional = false,
  optionalText = "(optional)",
  children,
  ...props
}: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(labelVariants({ variant }), className, "inline")}
      {...props}
    >
      {children}
      {optional && (
        <span className="text-body-small-regular text-mono-500 inline pl-1">
          {optionalText}
        </span>
      )}
    </LabelPrimitive.Root>
  );
}

export { Label, labelVariants };
